<template>
  <div class="navbar shadow-md flex items-center">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container flex-none hover hover:opacity-75 transition-all cursor-pointer"
      @toggleClick="toggleSideBar"
    />

    <div class="flex-grow">
      <el-select
        v-if="activeCharityId && allCharities && allCharities.length > 1"
        :value="activeCharityId"
        class="lg:w-full font-bold xl:w-4/5 w-1/2"
        popper-class="lg:w-full xl:w-4/5 w-1/2"
        filterable
        placeholder="Select Charity"
        @change="setCharity"
      >
        <el-option
          v-for="item in allCharities"
          :key="item.charity_id"
          :label="item.name"
          :value="item.charity_id"
        >
        </el-option>
      </el-select>
      <span v-else-if="activeCharityInfo" class="title select-charity-title">{{
        activeCharityInfo.charity_name
      }}</span>
    </div>

    <div class="flex">
      <div>
        <el-dropdown class="ml-4 lg:ml-2" trigger="click" placement="bottom" @command="navigate">
          <el-button
            type="primary"
            plain
            size="small"
            class="quick-actions-btn shadow-none"
            aria-label="Quick Actions"
            aria-haspopup="true"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
          </el-button>

          <el-dropdown-menu slot="dropdown" class="quick-actions quick-actions-menu">
            <div class="text-center bg-primary-dark text-white py-3 rounded-t-md">
              <div><b>Quick Actions</b></div>
              <span class="text-xs">What would you like to do:</span>
            </div>

            <div class="grid grid-cols-2">
              <el-dropdown-item :command="{ name: 'messagesNew' }" class="text-center">
                <img
                  :src="require('./Sidebar/007-donation-1.svg')"
                  class="w-12 mx-auto mt-4"
                  alt="icon"
                />
                <span class="inline-block mb-4">Send a Message</span>
              </el-dropdown-item>
              <el-dropdown-item
                :command="{ name: 'lists', query: { create: 1 } }"
                class="text-center"
              >
                <img
                  :src="require('./Sidebar/028-clipboard.svg')"
                  class="w-12 mx-auto mt-4"
                  alt="icon"
                />
                <span class="inline-block mb-4">Create a List</span>
              </el-dropdown-item>
              <el-dropdown-item :command="{ name: 'campaignAdd' }" class="text-center">
                <img
                  :src="require('./Sidebar/015-donation-7.svg')"
                  class="w-12 mx-auto mt-4"
                  alt="icon"
                />
                <span class="inline-block mb-4">Add a Campaign</span>
              </el-dropdown-item>
              <el-dropdown-item :command="{ name: 'impactPostAdd' }" class="text-center">
                <img
                  :src="require('./Sidebar/010-donation-3.svg')"
                  class="w-12 mx-auto mt-4"
                  alt="icon"
                />
                <span class="inline-block mb-4">Add Impact Post</span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="showOfflineDonations"
                :command="{ name: 'addADonation', query: { 'create-new': true } }"
                class="text-center"
              >
                <img
                  :src="require('./Sidebar/donation.png')"
                  class="w-12 mx-auto mt-4"
                  alt="icon"
                />
                <span class="inline-block mb-4">Add a Donation</span>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="md:hidden">
        <el-dropdown class="ml-4 lg:ml-2" trigger="click" placement="bottom" @command="navigate">
          <el-button
            type="primary"
            plain
            size="small"
            class="quick-actions-btn shadow-none"
            aria-label="Reports"
            :aria-haspopup="menu"
          >
            <font-awesome-icon :icon="['fas', 'chart-bar']" />
          </el-button>
          <el-dropdown-menu slot="dropdown" class="sm:w-full quick-actions quick-reports">
            <div class="grid grid-cols-2 bg-primary-dark text-white py-3 rounded-t-md">
              <b class="px-5">Reports</b>
              <b class="px-5">Donations</b>
            </div>
            <div class="flex flex-wrap">
              <div class="w-1/2">
                <el-dropdown-item :command="{ name: 'reports' }">Analytics</el-dropdown-item>
                <el-dropdown-item :command="{ name: 'reportsDonation' }"
                  >Donations</el-dropdown-item
                >
                <el-dropdown-item :command="{ name: 'reportsMonthly' }">Monthly</el-dropdown-item>
                <el-dropdown-item :command="{ name: 'reportsRoundUps' }"
                  >Round-Ups</el-dropdown-item
                >
                <el-dropdown-item :command="{ name: 'reportsCampaigns' }"
                  >Campaigns</el-dropdown-item
                >
              </div>

              <div class="w-1/2">
                <el-dropdown-item
                  class="with-dot"
                  :command="{
                    name: 'reports',
                    query: {
                      'start-date': moment().format('MM-DD-YYYY'),
                      'end-date': moment().format('MM-DD-YYYY'),
                    },
                  }"
                  >Today
                </el-dropdown-item>
                <el-dropdown-item
                  class="with-dot"
                  :command="{
                    name: 'reports',
                    query: {
                      'start-date': moment().subtract(6, 'days').format('MM-DD-YYYY'),
                      'end-date': moment().format('MM-DD-YYYY'),
                    },
                  }"
                  >Last 7 Days
                </el-dropdown-item>
                <el-dropdown-item
                  class="with-dot"
                  :command="{
                    name: 'reports',
                    query: {
                      'start-date': moment().subtract(29, 'days').format('MM-DD-YYYY'),
                      'end-date': moment().format('MM-DD-YYYY'),
                    },
                  }"
                  >Last 30 Days
                </el-dropdown-item>
                <el-dropdown-item
                  class="with-dot"
                  :command="{
                    name: 'reports',
                    query: {
                      'start-date': moment().startOf('month').format('MM-DD-YYYY'),
                      'end-date': moment().format('MM-DD-YYYY'),
                    },
                  }"
                  >This Month
                </el-dropdown-item>
                <el-dropdown-item
                  class="with-dot"
                  :command="{
                    name: 'reports',
                    query: {
                      'start-date': moment().startOf('year').format('MM-DD-YYYY'),
                      'end-date': moment().format('MM-DD-YYYY'),
                    },
                  }"
                  >This Year
                </el-dropdown-item>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="md:hidden">
        <el-dropdown
          class="ml-4 lg:ml-2"
          trigger="click"
          placement="bottom"
          @visible-change="messagesShown"
          @command="navigate"
        >
          <el-button
            type="primary"
            plain
            size="small"
            class="quick-actions-btn shadow-none"
            aria-label="Messages"
            aria-haspopup="true"
          >
            <font-awesome-icon :icon="['fas', 'comment']" />
          </el-button>
          <el-dropdown-menu slot="dropdown" class="sm:w-full quick-actions quick-messages">
            <div class="text-center bg-primary-dark text-white py-3 rounded-t-md">
              <div><b>Messages Inbox</b></div>
              <span class="text-xs"
                >You have <strong>{{ unreadMsgCount }}</strong> unread messages:</span
              >
            </div>

            <el-dropdown-item
              v-for="(msg, index) in lastMessages"
              :key="index"
              :command="{ name: 'messages', query: { thread_id: msg.uid } }"
            >
              <div class="py-4">
                <div class="float-left relative">
                  <el-avatar
                    v-if="msg.donor"
                    :size="46"
                    class="align-middle border-2 border-white shadow-md"
                    :src="(msg.donor.profile_photo && msg.donor.profile_photo) || null"
                    >{{ msg.donor.short_name }}
                  </el-avatar>
                  <span v-if="!msg.is_read" class="count"></span>
                </div>

                <div class="ml-16">
                  <div v-if="msg.donor" class="relative leading-5">
                    <span class="font-semibold text-base">{{ msg.donor.name }}</span>
                    <span class="text-xs opacity-50 absolute top-0 right-0"
                      >{{ msg.timestamp | sinceTime(dateNow) }} ago</span
                    >
                  </div>
                  <div class="cut-nowrap opacity-70 leading-5 h-5">
                    {{ msg.body }}
                  </div>
                </div>
              </div>
            </el-dropdown-item>

            <el-dropdown-item
              :command="{ name: 'messages' }"
              class="mt-2 text-center bg-gray-100 py-3 rounded-b-md"
              >View Messages
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-dropdown class="avatar-container flex-none" trigger="click">
      <span>
        <span v-if="adminInfo" class="inline-block text-xs text-right align-middle mr-3 md:hidden">
          <b>{{ adminInfo.first_name }} {{ adminInfo.last_name }}</b
          ><br />
          {{ adminInfo.email }}
        </span>

        <el-avatar
          v-if="adminInfo"
          class="align-middle border-2 border-white shadow-md"
          :src="(adminInfo.profile_photo && adminInfo.profile_photo) || null"
          >{{ { fname: adminInfo.first_name, lname: adminInfo.last_name } | shortName }}
        </el-avatar>

        <font-awesome-icon class="ml-1 text-xs text-gray-400" :icon="['far', 'chevron-down']" />
      </span>

      <el-dropdown-menu slot="dropdown" class="user-dropdown quick-actions">
        <div v-if="adminInfo" class="bg-primary-dark text-white py-3 px-6 rounded-t-md">
          <b>{{ adminInfo.first_name }} {{ adminInfo.last_name }}</b
          ><br />
          <span class="text-xs opacity-90">{{ adminInfo.email }}</span>
        </div>
        <router-link :to="{ name: 'settingsAccount' }">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'user-circle']" class="mr-2" />
            My Account
          </el-dropdown-item>
        </router-link>

        <router-link :to="{ name: 'settingsOrganization' }">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'building']" class="mr-2" />
            Organization
          </el-dropdown-item>
        </router-link>

        <router-link :to="{ name: 'settingsTeammates' }">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'envelope-open-text']" class="mr-2" />
            Invite Teammates
          </el-dropdown-item>
        </router-link>

        <router-link :to="{ name: 'settingsBilling' }">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'credit-card']" class="mr-2" />
            Billing Plan
          </el-dropdown-item>
        </router-link>

        <el-dropdown-item>
          <button aria-haspopup="true" @click.prevent="onUpgradePlanClicked">
            <font-awesome-icon fixed-width :icon="['far', 'angle-double-up']" class="mr-2" />
            Upgrade Plan
          </button>
        </el-dropdown-item>
        <a target="_blank" href="/refer" @click.prevent="onReferClicked">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'comment-alt-dollar']" class="mr-2" />
            Refer a Nonprofit
          </el-dropdown-item>
        </a>
        <a target="_blank" href="http://help.harnessapp.com/">
          <el-dropdown-item>
            <font-awesome-icon fixed-width :icon="['far', 'question-circle']" class="mr-2" />
            Need Help
          </el-dropdown-item>
        </a>
        <el-dropdown-item divided @click.native="logout">
          <font-awesome-icon fixed-width :icon="['far', 'sign-out-alt']" class="mr-2" />Log Out
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'
import auth from '@/auth/authService'
import { filterDonorById } from '@/utils/donors'
import { launchdarklyKeys } from '@/utils/launchdarklyKeys'
import * as amplitude from '@amplitude/analytics-browser'

const moment = require('moment')

export default {
  components: {
    Hamburger,
  },
  data() {
    return {
      dateNow: moment(),
      showOfflineDonations: false,
      upgradePlanModalVisible: false,
      menu: false,
    }
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      activeCharityId: (state) => state.auth.activeCharityId,
      activeCharityInfo: (state) => state.charities.activeCharityInfo,
      adminInfo: (state) => state.auth.adminInfo,
      allCharities: (state) => state.charities.charities,
      donors: (state) => state.donors.donors,
      donorsState: (state) => state.donors.donorsState,
    }),
    lastMessages() {
      if (this.donorsState === 'ready') {
        return this.$store.getters['messages/getLastMessages'](this.activeCharityId).map((msg) => ({
          ...msg,
          donor: filterDonorById(msg.uid, this.donors),
        }))
      }
      return []
    },
    unreadMsgCount() {
      return Object.entries(
        this.$store.getters['messages/getUnreadCount'](this.activeCharityId)
      ).reduce((res, [, val]) => res + val, 0)
    },
  },
  mounted() {
    this.$launchDarkly.getClient().then((ldClient) => {
      this.showOfflineDonations = ldClient.variation(launchdarklyKeys.showOfflineDonations, false)
    })
  },
  methods: {
    messagesShown(isVisible) {
      if (isVisible) {
        let threads = JSON.parse(
          JSON.stringify(this.$store.getters['messages/getThreads'](this.activeCharityId))
        )

        threads = threads.sort((a, b) => {
          let t1 = moment(a.timestamp)
          let t2 = moment(b.timestamp)

          if (t1 > t2) {
            return -1
          } else if (t1 < t2) {
            return 1
          }
          return 0
        })

        threads = threads.slice(0, 4)
        for (let i = 0; i < threads.length; i++) {
          this.$store.dispatch(
            'messages/updateThreadIfEmpty',
            { uid: threads[i].uid, charity_id: this.activeCharityId },
            { root: true }
          )
        }
      }
    },
    moment() {
      return moment()
    },
    navigate(route) {
      this.$router.push(route)
    },
    setCharity(charityId) {
      this.$store.commit('auth/SET_ACTIVE_CHARITY_ID', charityId)
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      auth.logOut()
    },
    async onReferClicked(e) {
      e.preventDefault()
      amplitude.track({
        event_type: 'Button Clicked',
        event_properties: {
          action: 'Refer a Nonprofit',
        },
        groups: { charityId: this.activeCharityId },
      })
      await this.$router.push({ name: 'refer' })
    },
    onUpgradePlanClicked() {
      amplitude.track({
        event_type: 'Menu Item Clicked',
        event_properties: {
          action: 'upgrade plan clicked',
        },
        groups: { charityId: this.activeCharityId },
      })
      this.$emit('upgradePlanModalVisible', true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/tokens';
.navbar {
  height: 69px;
  overflow: hidden;
  position: relative;
  background: $token-color-card-bg;

  .avatar-container {
    margin-right: 20px;

    .avatar-wrapper {
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
